import ErnstigeBloedingenOnderDoacFactorXa from "../../../../src/client/lta-antistolling/ernstige-bloedingen-onder-doac-factor-xa.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  ErnstigeBloedingenOnderDoacFactorXa,
  ChartCollapse,
  React
};